import React from "react";
import { Container, Row, Col, Button, Badge } from "react-bootstrap";
import logo from "../assests/logo_1.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer
        className="pt-5"
        style={{ backgroundColor: "#721213", color: "white" }}
      >
        <Container>
          {/* Main Footer Content */}
          <Row>
            {/* Company Logo and Info */}
            <Col md={3} className="mb-4">
              <div className="mb-3">
                <img src={logo} alt="Machinerex" style={{ maxWidth: "100%" }} />
              </div>
              <p>
                Founded by engineers with over two decades of expertise in
                manufacturing and supply chain management, PreciseAxis is a
                trusted name in engineering excellence
              </p>
              <div>{/* <h6>Customer Service</h6> */}</div>
            </Col>

            {/* Quick Links */}
            <Col md={3} className="mb-4">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/" className="text-white">
                    <i class="bi bi-chevron-right"></i>Home
                  </Link>
                </li>
                <li>
                  <Link to="/AboutUs" className="text-white">
                    <i class="bi bi-chevron-right"></i>About Us
                  </Link>
                </li>
                <li>
                  <Link to="/capability" className="text-white">
                    <i class="bi bi-chevron-right"></i>Capabilities
                  </Link>
                </li>
                <li>
                  <Link to="/equipment" className="text-white">
                    <i class="bi bi-chevron-right"></i>Product Gallery
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-white">
                    <i class="bi bi-chevron-right"></i>Contact Us
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Our Service */}
            <Col md={3} className="mb-4">
              <h5>Our Capabilities</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/capability" className="text-white">
                    <i class="bi bi-chevron-right"></i>Customized Cutting Tools
                    & Machinery Consumables
                  </Link>
                </li>
                <li>
                  <Link to="/capability" className="text-white">
                    <i class="bi bi-chevron-right"></i>CAD/CAM Engineering
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/capability" className="text-white">
                    <i class="bi bi-chevron-right"></i>Precision Manufactured
                    Components
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Get in Touch */}
            <Col md={3} className="mb-4">
              <h5>Get in Touch</h5>
              <p className="d-flex align-items-start gap-2">
                <i
                  class="fa-solid fa-location-dot mt-3 fa-xl"
                  style={{ color: "#F39C12" }}
                ></i>{" "}
                No. 880 , Rajiv Gandhi Nagar, Bangalore 560097,India
              </p>
              <p className="d-flex align-items-start gap-2">
                <i
                  class="fa-solid fa-location-dot mt-3 fa-xl"
                  style={{ color: "#F39C12" }}
                ></i>{" "}
                15728,Lorain Ave, Unit #170 , Cleveland , OH 44111 , USA
              </p>
              <p className="d-flex align-items-center gap-2">
                <i
                  className="bi bi-envelope-fill"
                  style={{ color: "#F39C12" }}
                ></i>
                sales@preciseaxis.com
              </p>
              <p className="d-flex align-items-center gap-2">
                <i
                  className="bi bi-envelope-fill"
                  style={{ color: "#F39C12" }}
                ></i>
                preciseaxis@gmail.com
              </p>
              <p className="d-flex align-items-center gap-2">
                <i
                  className="bi bi-telephone-fill"
                  style={{ color: "#F39C12" }}
                ></i>
                (+91) 8951960110 <br /> +1 216 800-7148
              </p>
            </Col>
          </Row>

          {/* Footer Bottom */}
          <Row className="pt-3 border-top" style={{ borderColor: "#F39C12" }}>
            <Col
              md={12}
              className=" d-flex justify-content-center align-items-center"
            >
              <p className="mb-0">
                &copy; 2024 All Rights Reserved | Design by ParNets
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Footer;
